import * as agenciesApi from '@/network/api/agencies.api.js'

/** requests Agencies List
@return { promise } - Agencies List request
*/
export const requestAgenciesList = async (context, payload) => {
    const res = await agenciesApi.requestAgenciesList()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AGENCIES_LIST', data)
    }
    return res
}

/** requests Agencies Provinces List
@return { promise } - Agencies Provinces List request
*/
export const requestAgenciesProvinces = async (context, payload) => {
    const res = await agenciesApi.requestAgenciesProvinces()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AGENCIES_PROVINCES', data)
    }
    return res
}

/** requests NonAuthenticated Agencies List
@return { promise } - Agencies List request
*/
export const requestNonAuthenticatedAgenciesList = async (context, payload) => {
    const res = await agenciesApi.requestNonAuthenticatedAgenciesList()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AGENCIES_LIST', data)
    }
    return res
}

/** requests NonAuthenticated Agencies Provinces List
@return { promise } - Agencies Provinces List request
*/
export const requestNonAuthenticatedAgenciesProvinces = async (context, payload) => {
    const res = await agenciesApi.requestNonAuthenticatedAgenciesProvinces()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_AGENCIES_PROVINCES', data)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
